<template>
  <div class="app-main-content voucher-maintenance">
    <div class="tabs-container">
      <div class="grid-view">
        <div v-show="pageMode === 0" class="main-content voucher-list">
          <search-item
            config-module="1700"
            :reset="true"
            :custom-sim-query-placeholder="$t('SystemMaintenance.QuickSearchAdNumber')"
            :auto-init="searchItemAutoInit"
            :custom-search-items="customSearchItems"
            @click-more="value=>isAdvancedQuery=value"
            @simSearchItemCallBack="toSimpleQuery"
            @advSearchItemCallBack="toAdvancedQuery"
          >
            <div slot="operations" class="triggers">
              <!--新增-->
              <el-button type="primary" @click="toNew">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
              <!--删除-->
              <el-button type="danger" @click="toDelete">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
              <!--查看-->
              <el-button type="primary" @click="toView">{{ $t('CargoMsg.Cargo_View') }}</el-button>
              <!--下架-->
              <el-button type="primary" @click="toOffShelf">{{ $t('SystemMaintenance.Remove') }}</el-button>
              <!--发布-->
              <el-button type="primary" @click="toPush">{{ $t('SystemMaintenance.Publish') }}</el-button>
            </div>
          </search-item>
          <div class="section grid-wrapper">
            <cargo-ag-grid
              :grid-params.sync="gridParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              @gridReady="onReady"
            />
          </div>
          <div class="pagination-wrapper">
            <cargo-pagination
              :page-count="filter.pageCount"
              :total="filter.total"
              :page.sync="filter.pageNum"
              :limit.sync="filter.pageSize"
              @pagination="toQueryByPage"
            />
          </div>
        </div>
        <div v-show="pageMode === 1" class="main-content voucher-list">
          <ad-details ref="detail" @back="back" @toPush="doPush" @refresh="refreshList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading } from '@/utils/utilBaseElement'
import {
  deleteAConfigFunc,
  getAdvertisingSpaceForKeyFunc,
  queryAConfigFunc,
  updateACFunc
} from '@/api/sysManage/advertisingConfig'
import AdDetails from '@/views/cargo/v0/SystemMaintenance/components/Ad/AdDetails'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getAllTenant } from '@/api/sysManage/baseConfig/defaultValueManage'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'AdvertisingManagement',
  components: { AdDetails, searchItem },
  data() {
    return {
      gridParams: {},
      pageMode: 0, // 0 列表, 1 查看模式, 2 编辑模式
      loading: null,
      gridApi: null,
      selectedDataList: [],
      isAdvancedQuery: true,
      tenantList: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        onRowSelected: this.onRowSelected,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.toView,
        pagination: false
      },
      filterJson: {
        jobNo: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      selectedData: null,
      filter: {
        total: 0,
        pageNum: 1,
        pageCount: 0,
        pageSize: 10
      },
      columnDefs: [
        {
          headerName: '', field: '', width: 65, headerCheckboxSelection: true,
          checkboxSelection: true, sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false
        },
        { headerName: this.$t('SystemMaintenance.AdCode'), field: 'advertisementNo', width: 120 },
        { headerName: this.$t('SystemMaintenance.SubjectName'), field: 'title', width: 120 },
        { headerName: this.$t('SystemMaintenance.AdContent'), field: 'content', width: 200 },
        { headerName: this.$t('SystemMaintenance.Advertiser'), field: 'subjectName', width: 120 },
        { headerName: this.$t('SystemMaintenance.AdLocation'), field: 'advertisingSpaceTitle', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_INDEX_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.BelongsToPage'), field: 'page', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_PAGE_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.BelongsToModule'), field: 'module', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_MODULE_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.BelongingSystem'), field: 'systemSource', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_SYSTEM_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.Status'), field: 'status', width: 120,
          cellRenderer: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_STATUS_LIST, params.value)
            if (c) {
              if (params.value === '0') {
                return '<span style="color: #35a8e7">' + c.chineseName + '</span>'
              } else if (params.value === '1') {
                return '<span style="color: #da7832">' + c.chineseName + '</span>'
              } else if (params.value === '2') {
                return '<span style="color: #77ef06">' + c.chineseName + '</span>'
              } else if (params.value === '3') {
                return '<span style="color: rgba(91,94,94,0.49)">' + c.chineseName + '</span>'
              }
            }
            return params.value
          }
        },
        { headerName: this.$t('SystemMaintenance.TargetAudience'), field: 'pushObject', width: 120,
          valueFormatter: (params) => {
            return params.value === 'all' ? this.$t('SystemMaintenance.Global') : ''
          }
        },
        {
          headerName: this.$t('SystemMaintenance.Creator'), field: 'createdBy', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SystemMaintenance.CreationDate'), field: 'dateCreated', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SystemMaintenance.Modifier'), field: 'modifiedBy', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SystemMaintenance.ModificationDate'), field: 'dateModified', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SystemMaintenance.PromotionPeriod'), field: 'promotionCycle', width: 120,
          valueFormatter: (params) => {
            if (params.data.promotionCycleStat || params.data.promotionCycleStat) {
              return ColumnUtils.dateLabelFunc(params.data.promotionCycleStat) + '~' + ColumnUtils.dateLabelFunc(params.data.promotionCycleEnd)
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('SystemMaintenance.EffectiveTime'), field: 'promotionCycleStat', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SystemMaintenance.ExpirationTime'), field: 'promotionCycleEnd', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ],
      rowData: []
    }
  },
  computed: {},
  mounted() {

  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      await getAllTenant().then(resp => {
        this.tenantList = resp.data
      })
      const defaultSearchFields = []
      if (this.tenantList) {
        const dataProvider = []
        for (const tenant of this.tenantList) {
          const chineseName = tenant.name
          const englishName = tenant.englishName
          dataProvider.push({ code: tenant.id, chineseName: chineseName, englishName: englishName })
        }
        const searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        searchField.itemType = 'advanceSelect'
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'ac.SUBJECT'
        searchField.itemLabel = 'CargoMsg.Cargo_AdvertisingSubject'
        searchField.defaultSelected = 1
        searchField.action = 2
        searchField.fields = ['chineseName']
        searchField.tagName = 'chineseName'
        searchField.tagValue = 'code'
        searchField.subType = { filterable: true }
        searchField.dataProvider = dataProvider
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'ac.CREATED_BY'
      searchField.itemLabel = 'CargoMsg.Cargo_Creator'
      searchField.tagValue = 'userId'
      searchField.defaultSelected = 0
      searchField.subType = { filterable: true }
      searchField.dataProvider = getCacheListByKey(basicCacheKeys.basic_data_User)
      defaultSearchFields.push(searchField.formatObj2Json())

      this.customSearchItems = defaultSearchFields
      this.searchItemAutoInit = true
    },
    onReady(params) {
      this.gridApi = params.api
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery(this.filterJson.advertisementNo)
      }
    },
    toSimpleQuery(keyword) {
      this.filter.pageNum = 1
      this.filterJson.advertisementNo = keyword.trim()
      this.filterJson.conditions = []
      this.toQuery()
    },
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filterJson.advertisementNo = ''
      }
      this.toQuery(data)
    },
    toQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      queryAConfigFunc(this.filterJson).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.filter.pageCount = res.data.pages
      this.selectedData = null
      this.selectedDataList = []
      this.gridApi.clearFocusedCell()
      this.loading.close()
    },
    async toNew() {
      this.pageMode = 1
      await getAdvertisingSpaceForKeyFunc('indexTop').then(res => {
        if (res.data) {
          this.$refs.detail.onShow({ pushMaxNumber: String(res.data.pushMaxNumber) }, 'add', this.rowData)
        }
      })
    },
    toDelete() {
      if (!this.selectedDataList || this.selectedDataList.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      const index = this.selectedDataList.findIndex(p => p.status !== '0')
      if (index !== -1) {
        this.$message.warning(this.$t('SystemMaintenance.ContainsUnremovedData'))
        return
      }
      this.$confirm(this.$t('SystemMaintenance.AreYouWantToDelete'), this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        const data = {}
        data.uuids = this.selectedDataList.map(row => row.uuid)
        deleteAConfigFunc(data).then(res => {
          this.updatePage(data.uuids, 'delete')
        }).catch((err) => {
          this.$message.error(err)
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }).catch()
    },
    toView(event) {
      if (event) {
        this.onRowClicked(event)
      }
      if (!this.selectedData || !this.selectedData.uuid) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }
      if (this.selectedDataList && this.selectedDataList.length > 1) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseOnlySelectOneRecord'))
        return
      }
      this.pageMode = 1
      this.$refs.detail.onShow(this.selectedData, 'view', this.rowData)
    },
    toOffShelf() {
      if (!this.selectedDataList || this.selectedDataList.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      const index = this.selectedDataList.findIndex(p => p.status === '0')
      if (index !== -1) {
        this.$message.warning(this.$t('SystemMaintenance.ContainsAlreadyRemovedData'))
        return
      }
      this.$confirm(this.$t('SystemMaintenance.AreYouWantToRemove'), this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        const updateData = {}
        updateData.status = '0'
        updateData.uuids = this.selectedDataList.map(row => row.uuid)
        updateACFunc(updateData).then(res => {
          this.updatePage(updateData.uuids, 'update0')
        }).catch((err) => {
          this.$message.error(err)
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }).catch()
    },
    doPush(updateData) {
      this.$confirm(this.$t('SystemMaintenance.AreYouWantToPublish'), this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        getAdvertisingSpaceForKeyFunc(updateData.advertisingSpaceTitle).then(res => {
          if (res.data) {
            const d = res.data
            if (d.status === '3') {
              this.$message.warning(this.$t('SystemMaintenance.ThePositionHasBeenDisabled'))
              return
            }
            if (d.nowPushNumber >= d.pushMaxNumber) {
              this.$message.warning(this.$t('SystemMaintenance.TheReachedTheMaximumPlacements'))
              return
            }
            const num = updateData.uuids.length
            if (d.nowPushNumber + num > d.pushMaxNumber) {
              this.$message.warning(this.$t('SystemMaintenance.RemainingAreNotEnoughCheck'))
              return
            }
            updateACFunc(updateData).then(res => {
              this.updatePage(updateData.uuids, 'update1')
              this.toQueryByPage()
            }).catch((err) => {
              this.$message.error(err)
              this.loading.close()
            }).finally(() => {
              this.loading.close()
            })
          }
        }).catch((err) => {
          this.$message.error(err)
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }).catch()
    },
    toPush() {
      if (!this.selectedDataList || this.selectedDataList.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      const index = this.selectedDataList.findIndex(p => p.status === '1' || p.status === '2' || p.status === '3')
      if (index !== -1) {
        this.$message.warning(this.$t('SystemMaintenance.ContainsPublishedOrExpiredData'))
        return
      }
      const updateData = {}
      updateData.status = '1'
      updateData.uuids = this.selectedDataList.map(row => row.uuid)
      updateData.advertisingSpaceTitle = this.selectedDataList[0].advertisingSpaceTitle
      this.doPush(updateData)
    },
    refreshList(list) {
      this.rowData = list
      this.gridApi.refreshCells({ force: true })
    },
    back() {
      this.pageMode = 0
      this.toQueryByPage()
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
      this.onRowClicked(event)
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.uuid) {
        this.selectedData = node
      }
    },
    updatePage(uuids, action) {
      if (action === 'delete') {
        for (const d of uuids) {
          const index = this.rowData.findIndex(p => p.uuid === d)
          this.rowData.splice(index, 1)
          const index2 = this.selectedDataList.findIndex(p => p.uuid === d)
          this.selectedDataList.splice(index2, 1)
        }
      }
      if (action === 'update1') {
        for (const d of uuids) {
          const index = this.rowData.findIndex(p => p.uuid === d)
          this.rowData[index].status = '1'
        }
        this.gridApi.refreshCells({ force: true })
        if (this.pageMode === 1) {
          const index = this.rowData.findIndex(p => p.uuid === uuids[0])
          this.$refs.detail.onShow(this.rowData[index], 'view', this.rowData)
        }
      }
      if (action === 'update0') {
        for (const d of uuids) {
          const index = this.rowData.findIndex(p => p.uuid === d)
          this.rowData[index].status = '0'
        }
        this.gridApi.refreshCells({ force: true })
      }
    },
    toEdit() {
      this.pageMode = 1
    }
  }
}
</script>
